import React from 'react';
import { DERSLER } from '../../lib/dersler.js';
import { ZOOM_DEGERLERI, URUNLER } from './sabitler';
import { tikzBoyutTemizle } from './yardimcilar';
// Faz C (2026-09-03): Basim.js'ten satır aralığıyla BİREBİR taşındı — davranış değişmedi.

// Sade akış (2026-09-03): PDF / Yazdır düğmeleri önizleme başlığında da durur —
// öğretmen aşağı kaydırıp sayfaları gördükten sonra yukarı çıkmak zorunda kalmaz.
// `pdfPasif` (2026-09-15): yalnız PDF düğmesini kilitler (yayınevine teslim açık ama
// yayınevi seçilmedi / birim fiyat geçersiz) — Yazdır etkilenmez.
function OnizlemePaneli({ onizleme, gorselBoyut, cozumDosyasiAyri, zoomYuzde, onZoomDegis,
                          onAtlananlariCikar, onYeniPencere, onSablonKaydet, onPdf, onYazdir, ciktiPasif, pdfPasif = '' }) {
  // Çözümler PDF'in sonunda (2026-09-14, kullanıcı: "çözümler sayfa sonuna eklenmiyor"):
  // önizleme = basılan → çözüm sayfaları kitapçığın hemen ARDINDAN aynı akışta (eskiden
  // ayrı "Çözüm" sekmesindeydi). Kimlik çakışması yok: backend çözüm SVG'sine `c` kökü verir.
  const cozumVar = !!(cozumDosyasiAyri && onizleme.svg_cozum);
  const boyutClass = `basim-boyut-${gorselBoyut}`;
  // Faz 3: sayfa sayısı — backend (texlive pdf2svg adedi) yoksa SVG'deki sayfa
  // sarmalayıcıları (<div class="basim-sayfa">) sayılır.
  const sayfaSay = (svg) => (svg || '').split('class="basim-sayfa"').length - 1;
  const cozumSayfa = cozumVar ? sayfaSay(onizleme.svg_cozum) : 0;
  const sayfaSayisi = (onizleme.sayfa_sayisi || sayfaSay(onizleme.svg_ana)) + cozumSayfa;
  const zoomIndex = ZOOM_DEGERLERI.indexOf(zoomYuzde);
  const zoomAzalt = () => onZoomDegis(ZOOM_DEGERLERI[Math.max(0, zoomIndex - 1)]);
  const zoomArtir = () => onZoomDegis(ZOOM_DEGERLERI[Math.min(ZOOM_DEGERLERI.length - 1, zoomIndex + 1)]);
  const zoomSifirla = () => onZoomDegis(100);

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-1.5">
        <h3 className="text-sm font-bold text-gray-700 flex items-center gap-1.5">
          <span className="w-1 h-4 bg-purple-500 rounded" />
          Önizleme · {onizleme.soru_sayisi} soru
          {sayfaSayisi > 0 && (
            <span className="ml-1 px-1.5 py-0.5 rounded bg-purple-50 text-purple-700 text-[11px] font-semibold"
              title="Gerçek sayfa sayısı — PDF ile birebir aynı (aynı LaTeX derlemesi). Her sayfa aşağıda ayrı kutu; kırılma noktaları görünür.">
              {sayfaSayisi} sayfa{cozumSayfa > 0 ? ` · ${cozumSayfa} çözüm sayfası` : ''}
            </span>
          )}
        </h3>
        <div className="flex gap-1.5 items-center">
          {/* Zoom (D4) */}
          <div className="flex items-center bg-gray-100 rounded-lg p-0.5">
            <button onClick={zoomAzalt} disabled={zoomIndex === 0}
              className="px-1.5 text-xs disabled:opacity-30">−</button>
            <button onClick={zoomSifirla} className="text-[10px] px-1.5 font-mono">{zoomYuzde}%</button>
            <button onClick={zoomArtir} disabled={zoomIndex === ZOOM_DEGERLERI.length - 1}
              className="px-1.5 text-xs disabled:opacity-30">+</button>
          </div>
          <button onClick={onSablonKaydet}
            title="Bu ayarları şablon olarak kaydet"
            className="text-[11px] px-2 py-0.5 rounded bg-purple-50 text-purple-700 hover:bg-purple-100">💾 Şablon</button>
          <button onClick={() => onYeniPencere(cozumVar ? `${onizleme.svg_ana}${onizleme.svg_cozum}` : onizleme.svg_ana, cozumVar ? 'Kitapçık + çözümler' : 'Soru')}
            className="text-[11px] px-2 py-0.5 rounded bg-gray-100 hover:bg-gray-200 text-gray-700">↗ Pencere</button>
          {onPdf && (
            <button onClick={onPdf} disabled={!!ciktiPasif || !!pdfPasif} title={ciktiPasif || pdfPasif || 'PDF İndir — önizlenen kitapçığın aynısı'}
              className="text-[11px] px-2.5 py-0.5 rounded bg-green-600 text-white font-semibold hover:bg-green-700 disabled:opacity-40">⬇️ PDF</button>
          )}
          {onYazdir && (
            <button onClick={onYazdir} disabled={!!ciktiPasif} title={ciktiPasif || 'Yazdır — önizlenen kitapçığın aynısı'}
              className="text-[11px] px-2.5 py-0.5 rounded bg-gray-700 text-white font-semibold hover:bg-gray-800 disabled:opacity-40">🖨️ Yazdır</button>
          )}
        </div>
      </div>

      {/* TAM DENEME RAPORU (2026-08-18): gerçekleşen test/ders/kova dağılımı.
          "borç" = hedef kovada yeterli soru yoktu, komşu kovadan (örn. zor
          yerine 6-7 puanlı orta) tamamlandı — sessiz bozulma yerine şeffaf rozet. */}
      {onizleme.deneme_raporu && (
        <div className="bg-indigo-50 border border-indigo-200 rounded p-2 text-[11px] text-indigo-900 mb-2">
          <div className="font-bold mb-1">
            {(() => {
              // Ürün adı sınav türünden (slot-ders 2026-09-03: "AYT_SOZEL" ham ENUM basılmaz).
              if (onizleme.secim_kaynagi === 'genel_deneme') return `Genel deneme (${onizleme.sinav_turu || ''}, ÖSYM çok-testli)`;
              const u = Object.values(URUNLER).find(x => x.sinav === onizleme.sinav_turu);
              const ad = u ? u.ad : `${onizleme.sinav_turu || ''} Denemesi`;
              return /Denemesi$/.test(ad) ? ad : `${ad} denemesi`;
            })()} — gerçekleşen dağılım{' '}
            {onizleme.deneme_raporu.gerceklesen_toplam}/{onizleme.deneme_raporu.hedef_toplam} soru
            {onizleme.yok_sayilan_filtreler?.length > 0
              && ` · yok sayılan filtreler: ${onizleme.yok_sayilan_filtreler.join(', ')}`}
          </div>
          <div className="space-y-0.5">
            {(onizleme.deneme_raporu.testler || []).map(t => (
              <div key={t.kod} className="flex flex-wrap items-baseline gap-x-2">
                <span className="font-semibold min-w-[110px]">{t.ad}:</span>
                {t.dersler.map(d => {
                  const borc = d.kova
                    ? (d.kova.kolay.borc + d.kova.orta.borc + d.kova.zor.borc) : 0;
                  const kovaOzet = d.kova
                    ? `kolay ${d.kova.kolay.gerceklesen}/${d.kova.kolay.hedef} · orta ${d.kova.orta.gerceklesen}/${d.kova.orta.hedef} · zor ${d.kova.zor.gerceklesen}/${d.kova.zor.hedef}`
                    : '';
                  return (
                    <span key={d.ders} title={kovaOzet + (borc > 0 ? ` — ${borc} soru komşu kovadan` : '')}
                      className={`px-1.5 py-0.5 rounded ${d.gerceklesen < d.hedef
                        ? 'bg-red-200 text-red-900 font-bold' : 'bg-white/70'}`}>
                      {d.ad || (DERSLER.find(x => x.value === d.ders)?.label || d.ders).replace(/^(TYT|AYT)\s+/i, '')}{' '}
                      <strong>{d.gerceklesen}</strong>/{d.hedef}
                      {borc > 0 && <span className="text-amber-700"> ⚠{borc}</span>}
                    </span>
                  );
                })}
              </div>
            ))}
          </div>
          <div className="mt-1 text-[10px] opacity-75">
            ⚠N = hedef zorluk kovasında yeterli soru olmadığı için komşu kovadan tamamlanan soru sayısı.
          </div>
        </div>
      )}

      {/* Basım kapsamı (2026-08-13): basımın GERÇEKTE hangi ders/dağılımla
          çalıştığı ve sessizce elenenler. Öncesinde ders kilidi ve 1-puan
          elemesi kullanıcıya hiç görünmüyordu. */}
      {(onizleme.ders_kapsami || onizleme.dusuk_puan_elenen > 0) && (
        <div className="bg-slate-50 border border-slate-200 rounded p-2 text-[11px] text-slate-700 mb-2 space-y-0.5">
          {onizleme.ders_kapsami && (
            <div>
              Kapsam:{' '}
              <strong>
                {onizleme.ders_kapsami === 'matematik_geometri_varsayilan'
                  ? 'Ders seçilmedi → Matematik + Geometri'
                  : onizleme.ders_kapsami === 'secili_sorular'
                    ? 'Elle seçilen sorular'
                    : (DERSLER.find(d => d.value === onizleme.ders_kapsami)?.label || onizleme.ders_kapsami)}
              </strong>
              {onizleme.deneme_hedef_adet != null && (
                <> · deneme hedefi <strong>{onizleme.deneme_hedef_adet}</strong> soru</>
              )}
              {onizleme.talep_edilen_sayi != null && onizleme.talep_edilen_sayi !== onizleme.soru_sayisi && (
                <> · istenen {onizleme.talep_edilen_sayi}, basılan {onizleme.soru_sayisi}</>
              )}
            </div>
          )}
          {onizleme.dusuk_puan_elenen > 0 && (
            <div>
              <strong>{onizleme.dusuk_puan_elenen} soru</strong> satılabilir olmadığı için (onaysız, puan eşiği altı, düzeltme bekliyor vb.) havuzdan elendi
              {onizleme.dusuk_puan_elenen_public_no?.length > 0
                && ` (#${onizleme.dusuk_puan_elenen_public_no.join(', #')})`}.
            </div>
          )}
        </div>
      )}

      {/* Atlanan sorular bildirim (B6) */}
      {onizleme.atlanan_sayisi > 0 && (
        <div className="bg-amber-50 border border-amber-300 rounded p-2 text-[11px] text-amber-800 mb-2">
          <div className="flex items-start justify-between gap-2">
            <div>
              <strong>{onizleme.atlanan_sayisi} soru</strong> derleme hatası nedeniyle basıma alınamadı; kalan{' '}
              <strong>{onizleme.soru_sayisi}</strong> soru render edildi.
            </div>
            <button onClick={onAtlananlariCikar}
              className="px-2 py-0.5 rounded bg-amber-600 text-white text-[10px] font-semibold hover:bg-amber-700 whitespace-nowrap">
              ✕ Bunları Çıkar
            </button>
          </div>
          {onizleme.atlanan_sorular?.length > 0 && (
            <details className="mt-1">
              <summary className="cursor-pointer text-amber-700">Atlanan soruları gör</summary>
              <ul className="mt-1 ml-3 list-disc space-y-0.5">
                {onizleme.atlanan_sorular.map((a, i) => (
                  <li key={i}>#{a.public_no} {a.konu} — <span className="text-amber-600 italic">{a.hata}</span></li>
                ))}
              </ul>
            </details>
          )}
        </div>
      )}
      {onizleme.cozum_basarili === false && cozumDosyasiAyri && (
        <div className="bg-orange-50 border border-orange-300 rounded p-2 text-[11px] text-orange-700 mb-2">
          Çözümler derlenemedi (PDF’e eklenmez): {onizleme.cozum_hata || 'bilinmeyen hata'}
        </div>
      )}

      <div className="bg-gray-50 rounded-lg p-3 max-h-[640px] overflow-y-auto">
        <div className={`onizleme-zoom onizleme-zoom-${zoomYuzde}`}>
          <div id="basim-onizleme-ana" className={`osym-onizleme ${boyutClass}`}
            dangerouslySetInnerHTML={{ __html: tikzBoyutTemizle(onizleme.svg_ana) }} />
          {cozumVar && (
            <>
              <div data-onizleme-cozum-ayrac className="my-3 text-center text-[11px] font-semibold text-emerald-700">
                — Çözümler (PDF’in sonunda) —
              </div>
              <div id="basim-onizleme-cozum" className={`osym-onizleme ${boyutClass}`}
                dangerouslySetInnerHTML={{ __html: tikzBoyutTemizle(onizleme.svg_cozum) }} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default OnizlemePaneli;
